module.exports = __webpack_public_path__ + "fonts/rw-widgets-eceddf4.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-widgets/dist/fonts/rw-widgets.ttf?v=4.1.0
// module id = 226
// module chunks = 6